var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[_vm.colorClass, _vm.activeClass]},[(_vm.context)?[(_vm.$slots.default)?[_vm._t("default")]:_vm._e(),_vm._v(" "+_vm._s(_vm.$d(new Date(_vm.context), "short"))+" ")]:[_vm._v("---")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }